export default __webpack_public_path__ + "static/media/Dhyan-Mantra.a68dae05.mp3";